import React, { useEffect } from 'react'

import {
    useHistory
} from 'react-router-dom'

import { 
    Alert,
    BlueTint,
    TopBackgroundDiv,
    BottomBackgroundDiv
} from '../Styles/BaseStyles'

import { 
    ComponentsDiv,
    FPDiv,
    FPComponentsDiv,
    FPContentsDiv,
    QuickFillerButtonDiv,
    QuickFillerButton,
    TitleIconButton
} from '../Styles/Pages/ForgotPasswordStyles'

import ForgotPasswordFields from '../Components/Action/ForgotPasswordFields'
import ForgotPasswordConfirm from '../Components/Display/ForgotPasswordConfirm'

import { useSelector, useDispatch } from 'react-redux'

import { reset } from '../Redux/Slices/ForgotPasswordSlice'

function ForgotPassword(props){
    const dispatch = useDispatch()

    const emailSent = useSelector(state => state.forgotPassword.emailSent)
    const error = useSelector(state => state.forgotPassword.error)
    const errorPhrase = useSelector(state => state.forgotPassword.errorPhrase)

    let history = useHistory()

    useEffect(() => {
        if(error){
            const timeId = setTimeout(() => {
                dispatch(reset())
            }, 5000)
            return () => {
                clearTimeout(timeId)
            }
        }
    }, [dispatch,error])

    function mainPage(e){
        history.push('/')
    }

    return (
        <>
            <TopBackgroundDiv />
            <BottomBackgroundDiv />
            {error && <Alert style={{top: "0.5rem", position: "absolute"}}>{errorPhrase}</Alert>}
            <ComponentsDiv>
                <FPDiv>
                    <FPComponentsDiv>
                        <FPContentsDiv>
                            <QuickFillerButtonDiv>
                                <TitleIconButton />
                                <QuickFillerButton onClick={mainPage}><BlueTint>Q</BlueTint>uick<BlueTint>F</BlueTint>iller</QuickFillerButton>
                            </QuickFillerButtonDiv>
                            {!emailSent ? <ForgotPasswordFields /> : <ForgotPasswordConfirm />}
                        </FPContentsDiv>
                    </FPComponentsDiv>
                </FPDiv>
            </ComponentsDiv>
        </>
    )
}

export default ForgotPassword

